import { lazy } from "react";
import { Building2 } from "lucide-react";
import { CopyMyBooksLogo } from "./CopyMyBooksLogo";
import type { WebExtensions } from "@easytestdata/web-extension-types";

const RealCompanyPage = lazy(() => import("./RealCompanyPage"));
const CopyPage = lazy(() => import("./copy/CopyPage"));
const ConnectPage = lazy(() => import("./public/ConnectPage"));
const ConnectedPage = lazy(() => import("./public/ConnectedPage"));
const ContactPage = lazy(() => import("./public/ContactPage"));

const extensions: WebExtensions = {
  logo: CopyMyBooksLogo,
  routes: [
    { path: "/real-company", element: RealCompanyPage },
    { path: "/real-company/:sourceId/copy", element: CopyPage }
  ],
  navItems: [{ path: "/real-company", label: "Real company", icon: Building2 }],
  publicRoutes: [
    { path: "/p/connect", element: ConnectPage },
    { path: "/p/connected", element: ConnectedPage },
    { path: "/p/contact", element: ContactPage }
  ]
};

export default extensions;
